export function getTributeUrl(tributeId) {
  return window.location.origin + window.location.pathname + "?tribute=" + tributeId;
}

export function getShareText(tribute) {
  return "Check out this tribute to " + tribute.teacher + " from " + tribute.from + "! \u2764\uFE0F Step Up for Teachers";
}

export function getShareSubject(tribute) {
  return "A tribute to " + tribute.teacher + " \u2014 Step Up for Teachers";
}

export function openFacebookShare(url) {
  window.open(
    "https://www.facebook.com/sharer/sharer.php?u=" + encodeURIComponent(url),
    "_blank",
    "width=600,height=400"
  );
}

export function openEmailShare(url, tribute) {
  var subject = getShareSubject(tribute);
  var body = getShareText(tribute) + "\n\n" + url;
  window.open(
    "mailto:?subject=" + encodeURIComponent(subject) + "&body=" + encodeURIComponent(body)
  );
}
